import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  chatTitle: {
    id: 'decagon.chatTitle',
    defaultMessage: 'ClassPass Partner Support',
  },
  waitTime: {
    id: 'decagon.waitTime',
    defaultMessage: 'Less than a minute',
  },
  conversationHistoryTitle: {
    id: 'decagon.conversationHistoryTitle',
    defaultMessage: 'My conversations',
  },
  newConversation: {
    id: 'decagon.newConversation',
    defaultMessage: 'Send us a new message',
  },
  noConversations: {
    id: 'decagon.noConversations',
    defaultMessage: 'No conversations yet',
  },
  disclaimerHTML: {
    id: 'decagon.disclaimerHTML',
    defaultMessage:
      'This Chat Bot uses artificial intelligence to generate responses. ClassPass Partner Support and its 3rd-party vendors may monitor, translate, record and access chats to respond to you, and for quality, training, improvement and other purposes. More info: <privacy-policy-link>Privacy Policy</privacy-policy-link>',
  },
  inputPlaceholder: {
    id: 'decagon.inputPlaceholder',
    defaultMessage: 'Ask a detailed question...',
  },
});
